import React, { useState } from "react";
import {
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import SpareCard from "./SpareCard";

export default function SparePartsMain() {
    const [chosenCategory, setChosenCategory] = useState(false)
    const [chosenSupplier, setChosenSupplier] = useState(false)

    const handleCategoryClick= (event) => {
        setChosenCategory(true)
    }

    const handleSupplierClick= (event) => {
        setChosenSupplier(true)
    }


  return (
    <div>
      <div className="m-3 text-center" style={{maxWidth: '1000px'}}>
        {!chosenCategory &&
        <>
            <Button className="m-3 shadow-lg" color="dark" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}} onClick={()=>{handleCategoryClick()}}>Aufzugwellen</Button>
            <Button className="m-3 shadow-lg" color="dark" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}}>Zeiger</Button>
            <Button className="m-3 shadow-lg" color="dark" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}}>Sonstige Werkteile</Button>
            <Button className="m-3 shadow-lg" color="primary" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}}>Gläser</Button>
            <Button className="m-3 shadow-lg" color="primary" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}}>Dichtungen</Button>
            <Button className="m-3 shadow-lg" color="primary" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}}>Kronen</Button>
            <Button className="m-3 shadow-lg" color="success" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}}>Federstege</Button>
            <Button className="m-3 shadow-lg" color="success" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}}>Verbrauchsmaterial</Button>
            <Button className="m-3 shadow-lg" color="success" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}}>Werkzeug</Button>        
        </>
        }
        {(!chosenSupplier && chosenCategory) &&
        <>
          <button
            type="button"
            className="btn btn-outline-secondary d-flex align-items-center"
            onClick={()=>{setChosenCategory(false)}}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-left mr-1"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
              ></path>
            </svg>
            Zurück
          </button>
            <Button className="m-3 shadow-lg" color="dark" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}} onClick={()=>{handleSupplierClick()}}>Boley</Button>
            <Button className="m-3 shadow-lg" color="dark" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}}>Intern</Button>
            <Button className="m-3 shadow-lg" color="dark" outline style={{minHeight: '256px', minWidth: '256px', fontSize: '24px'}}>Evergreenparts</Button>        
        </>
        }
      </div>
    </div>
  );
}
